import { Signal } from "../models/signal";

export const isDisplayableSignal = (signal: Signal): boolean =>
  signal.net.trim() !== "" || signal.name.trim() !== "";

export const getSignalLabel = (sig: Signal): string => {
  const net = sig.net.trim();
  const name = sig.name.trim();
  if (net && name) {
    return `${net} (${name})`;
  }
  return net || name;
};

export const getSignalLabelFromList = (id: string, options: Signal[]): string => {
  const sig = options.find(s => s.id === id);
  return sig ? getSignalLabel(sig) : id;
};

export const getCombinedSignalLabel = (sig1: Signal, sig2: Signal): string => {
  return `${getSignalLabel(sig1)} - ${getSignalLabel(sig2)}`;
};
